// 3rd-party
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Button,
  Alert,
  TextField,
} from "@mui/material";

// Asset components
import cross from "../../assets/close-circle.svg";
import visiable from "../../assets/visiable.svg";
import edit from "../../assets/edit.svg";
import delete1 from "../../assets/delete.svg";

// Services
import { removeVideoByIndex } from "../../services/IndiaService";

// Config
import { appConfig } from "../../config/appConfig";

// Styles
import "./VideoGalleryDialog.scss";
import { UPLOADTYPE } from "../../models/enums/globalEnums";

interface VideoGalleryDialogProps {
  open: boolean;
  onClose: () => void;

  oldMedia?: any;
  setOldMedia?: any;
  oldThumbnail?: any;
  setOldThumbnail?: any;
  gridType?: any;
  setGridType?: any;
  newMedia?: any;
  setNewMedia?: any;
  newThumbnail?: any;
  setNewThumbnail?: any;
  setgridTitle?: any;
  gridTitle?: any;
  editingIndex?: any;
}

const VideoGalleryDialog: React.FC<VideoGalleryDialogProps> = ({
  open,
  onClose,

  oldMedia,
  setOldMedia,
  oldThumbnail,
  setOldThumbnail,
  gridType,
  setGridType,
  newMedia,
  setNewMedia,
  newThumbnail,
  setNewThumbnail,
  setgridTitle,
  gridTitle,
  editingIndex,
}) => {
  const [gridImages, setgridImages] = useState<string>("");
  const [gridThumbnail, setgridThumbnail] = useState<string>("");

  const [selectedThumbnail, setSelectedThumbnail] = useState<File[]>([]);
  const [selectedVideos, setSelectedVideos] = useState<File[]>([]);
  const [selectgridtitle, setselectgridtitle] = useState<string>("");

  const [error, setError] = useState<string | null>(null);
  const [videoPreview, setVideoPreview] = useState<string | null>(null);
  const [thumbnailpreview, setthumbnailpreview] =
    useState<string>("No thumbnail");

  const MAX_FILE_SIZE_MB = 2;
  const MAX_FILE_SIZE_MB1 = 100;
  const ALLOWED_TYPE = "video/mp4";

  const Videos =
    typeof gridImages === "string"
      ? gridImages
          .split(",")
          .map((img) => img.trim())
          .filter(Boolean)
      : [];
  useEffect(() => {
    if (oldMedia) {
      setgridImages(oldMedia);
    }
    if (oldThumbnail) {
      setgridThumbnail(oldThumbnail);
      setthumbnailpreview(
        `${appConfig.serviceUrls.commonURL}${oldThumbnail.trim()}`
      );
    }
    if (gridTitle) {
      setselectgridtitle(gridTitle);
    }
    if (newMedia) {
      setSelectedVideos(Array.isArray(newMedia) ? newMedia : []);
    }
    if (newThumbnail) {
      if (Array.isArray(newThumbnail)) {
        setSelectedThumbnail(newThumbnail);
        if (newThumbnail.length > 0) {
          setthumbnailpreview(URL.createObjectURL(newThumbnail[0]));
        }
      } else {
        setSelectedThumbnail([]);
      }
    }
    if (newThumbnail instanceof File || newThumbnail instanceof Blob) {
      setthumbnailpreview(URL.createObjectURL(newThumbnail));
    }
  }, [oldMedia, oldThumbnail, newMedia, newThumbnail]);

  const handleClose = () => {
    onClose();
    setgridThumbnail("");
    setgridImages("");
    setSelectedThumbnail([]);
    setSelectedVideos([]);

    setgridTitle(selectgridtitle);
  };

  const handleAdd = () => {
    setOldMedia(gridImages);
    setGridType(UPLOADTYPE.VIDEO);
    setOldThumbnail(gridThumbnail);

    setNewMedia(selectedVideos);
    setNewThumbnail(selectedThumbnail);

    handleClose();
  };
  const handleRemoveALL = () => {
    setgridImages("");
    setgridThumbnail("");

    setSelectedThumbnail([]);
    setSelectedVideos([]);

    setError(null);
    setVideoPreview("");
  };

  const handlePreview = (vid: string) => {
    setVideoPreview(vid);
  };

  const handleVideoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) {
      return;
    }

    if (file) {
      if (file.type !== ALLOWED_TYPE) {
        setError("Only .mp4 video files are allowed.");
        return;
      }

      if (file.size > MAX_FILE_SIZE_MB1 * 1024 * 1024) {
        setError("File size must be less than or equal to 100MB.");
        return;
      }

      setError(null);
    }
    const formData = new FormData();
    formData.append("videoUrls", file);
    setSelectedVideos([file]);
  };

  const handleThumbnailUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    if (fileExtension === "jfif") {
      setError(`Thumbnail type .jfif is not allowed: ${file.name}`);
      return;
    }

    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      setError(`Thumbnail size of ${file.name} must be ≤ 2MB.`);
      return;
    }

    setSelectedThumbnail([file]);
    setthumbnailpreview(URL.createObjectURL(file));
  };

  const handleRemovevideo = (imgIndex: number) => {
    const updatedImageUrls = removeVideoByIndex(gridImages, imgIndex);

    setgridImages(updatedImageUrls.join(","));
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setselectgridtitle(e.target.value);
  };

  return (
    <Dialog
      open={open}
      maxWidth={false}
      fullWidth
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "85vw",
          height: "85vh",
          maxWidth: "85vw",
          maxHeight: "90vh",
          overflow: "hidden",
          backgroundColor: "#fff",
        },
      }}
    >
      <DialogContent
        className="body1"
        sx={{
          padding: "0px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* HEADER */}
        <Box className="header1">
          <Typography className="header-text">
            <b>Video Upload</b>
          </Typography>
          <IconButton onClick={() => handleClose()} className="close-icon">
            {/* <CloseIcon /> */}
            <img src={cross} alt="visible" className="custom-icon2" />
          </IconButton>
        </Box>

        {/* BODY */}
        <Box
          className="content-wrapper"
          sx={{
            display: "flex",
            gap: "20px",
            padding: "20px",
            flex: 1,
            overflow: "auto",
            boxSizing: "border-box",
          }}
        >
          <Box>
            <Box sx={{ marginLeft: "40px" }}>
              <Typography sx={{ paddingLeft: "10px" }}>
                <b>Name</b>
              </Typography>
              <TextField
                name="description"
                value={selectgridtitle}
                onChange={handleChange}
                multiline
                rows={1}
                className="custom-select"
              />
              <Typography className="pdf-name-count123 ">
                {selectgridtitle?.length || 0}/40
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                padding: "10px",
                flex: 1,
                overflow: "auto",
                boxSizing: "border-box",
              }}
            >
              {/* LEFT PANEL */}
              <Box className="left-panel">
                <Box className="thumbnail-frame">
                  {selectedThumbnail.length > 0 ? (
                    <img
                      src={thumbnailpreview}
                      alt="New Thumbnail"
                      width={206}
                      height={206}
                    />
                  ) : gridThumbnail ? (
                    <img
                      src={gridThumbnail}
                      alt="Existing Thumbnail"
                      width={206}
                      height={206}
                    />
                  ) : (
                    <Typography>No thumbnail</Typography>
                  )}
                </Box>

                {/* {editingIndex === -1 && ( */}
                <Button className="edit-thumbnail" component="label">
                  {/* <EditIcon sx={{ width: "16px", height: "16px" }} /> */}
                  <img
                    src={edit}
                    alt="edit"
                    style={{
                      width: "20px",
                      height: "20px",
                      paddingRight: "5px",
                    }}
                  />
                  <Typography className="edit-thumb-text">
                    Edit Thumbnail
                  </Typography>
                  <input
                    type="file"
                    hidden
                    accept="image/jpeg,image/png"
                    onChange={handleThumbnailUpload}
                  />
                </Button>
                {/* )} */}
              </Box>

              {/* CENTER PANEL */}
              <Box className="center-panel1">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography className="uploaded-text">
                    <b>Uploaded Video</b>
                  </Typography>
                  <Button
                    onClick={() => handleRemoveALL()}
                    className="edit-thumbnail"
                    component="label"
                  >
                    {/* <DeleteIcon className="icon" /> */}
                    <img
                      src={delete1}
                      alt="delete"
                      style={{
                        width: "24px",
                        height: "24px",
                        paddingRight: "5px",
                      }}
                    />
                    <Typography className="edit-thumb-text">
                      Remove All
                    </Typography>
                  </Button>
                </Box>

                <Box className="image-list">
                  {selectedVideos.length === 0 &&
                    Videos.map((vid, index) => (
                      <Box key={index} className="image-row">
                        <Typography className="image-name">
                          {vid.split("/").pop()}
                        </Typography>
                        <Box className="icon-row">
                          <img
                            onClick={() => handlePreview(vid)}
                            src={visiable}
                            alt="visiable"
                            style={{
                              width: "28px",
                              height: "28px",
                              paddingRight: "5px",
                            }}
                          />

                          <img
                            onClick={() => handleRemovevideo(index)}
                            src={delete1}
                            alt="delete"
                            style={{
                              width: "24px",
                              height: "24px",
                              paddingRight: "5px",
                            }}
                          />
                        </Box>
                      </Box>
                    ))}

                  {/* New (Selected) Images */}
                  {selectedVideos.map((file: File, index: number) => (
                    <Box key={`new-${index}`} className="image-row">
                      <Typography className="image-name">
                        {file.name}
                      </Typography>
                      <Box className="icon-row">
                        <img
                          onClick={() =>
                            handlePreview(URL.createObjectURL(file))
                          }
                          src={visiable}
                          alt="visiable"
                          style={{
                            width: "28px",
                            height: "28px",
                            paddingRight: "5px",
                          }}
                        />

                        <img
                          onClick={() => {
                            const updated = [...selectedVideos];
                            updated.splice(index, 1);
                            setSelectedVideos(updated);
                          }}
                          src={delete1}
                          alt="delete"
                          style={{
                            width: "28px",
                            height: "28px",
                            paddingRight: "5px",
                          }}
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
                {/* {editingIndex === -1 && ( */}
                <Button className="add-button1" component="label">
                  <Typography>Browse Video</Typography>
                  <input
                    type="file"
                    hidden
                    accept="video/mp4"
                    // multiple
                    onChange={handleVideoUpload}
                  />
                </Button>
                {/* )} */}

                {error && <Alert severity="error">{error}</Alert>}
              </Box>
            </Box>
          </Box>

          {/* RIGHT PANEL */}
          <Box className="right-panel">
            <Box className="preview-box">
              {videoPreview == null || videoPreview === "" ? (
                <Typography className="preview-text">Video Preview</Typography>
              ) : (
                <video controls className="preview-video" src={videoPreview} />
              )}
            </Box>
            <Box className="action-buttons">
              <Button onClick={() => handleClose()} className="cancel-button">
                Cancel
              </Button>
              {/* {editingIndex === -1 && ( */}
              <Button onClick={() => handleAdd()} className="save-button">
                Add
              </Button>
              {/* )} */}
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VideoGalleryDialog;
